import styles from '~/styles/wrapper/section/section.module.scss'

import { ChildProps } from '~/common/define/props'
import { addClass } from '~/common/utils/html'

export enum MainContentType {
  NORMAL,
  CENTER,
  WIDE,
  ONLY,
  NO
}

interface Props extends ChildProps {
  type?: MainContentType
}

const MainContent = ({children, type = MainContentType.NORMAL}: Props) => {
  const typeClass = type == MainContentType.NORMAL ? styles.normal : type == MainContentType.CENTER ? styles.center :
    type == MainContentType.WIDE ? styles.wide : type == MainContentType.ONLY ? styles.only :
      type == MainContentType.NO ? styles.no : ''

  return (
    <div className={styles.main + addClass(typeClass)}>
      {children}
    </div>
  )
}

export default MainContent